module.exports = __webpack_public_path__ + "static/media/childs-diet.d8c2fd53.jpeg";